// extracted by mini-css-extract-plugin
export default {"confirm-page-wrapper":"confirm_confirm-page-wrapper_X5si_","confirm-page-container":"confirm_confirm-page-container_NXxdq"};